module.exports = __webpack_public_path__ + "static/media/FloorScrape1_Before.07d23af1.jpg";